import { ApiService }                  from '../../app-lite/api/api.service';
import { BusinessIntelligenceService } from '../../app-lite/business-intelligence/business-intelligence.service';

import BranchContactsHtml      from './branch.contacts.html';
import BranchesDashboardHtml   from '../../app-lite/branches/branches.dashboard.html';
import BranchSettingsHtml      from './branches.settings.html';
import BranchStockTransferHtml from '../../app-lite/branches/branches.stock-transfer.html';

export function BranchesStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    abstract: true,
    name    : 'app.branches',
    url     : '/branches'
  })
  .state({
    controller : 'BranchesSettingsCtrl',
    name       : 'app.branches.settings',
    templateUrl: BranchSettingsHtml,
    url        : '/settings',
    resolve    : {
      franchiseLink: ( branchesApi : any ) : ng.IPromise<any> => branchesApi.getFranchiseLink(),
      settings     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_accounting_settings')
    }
  })
  .state({
    controller : 'BranchesDashboardCtrl',
    name       : 'app.branches.dashboard',
    templateUrl: BranchesDashboardHtml,
    url        : '/dashboard',
    resolve    : {
      linkedCompanies               : ( branchesApi : any ) : ng.IPromise<any> => branchesApi.getLinkedCompanies(),
      stats                         : ( branchesApi : any ) : ng.IPromise<any> => branchesApi.getStats(),
      businessIntelligenceDashboards: ( $q : ng.IQService, $rootScope : any, businessIntelligenceApi : BusinessIntelligenceService ) : ng.IPromise<any> | ng.IPromise<object> =>
        $rootScope.Company.hasIntegration('business-intelligence')
          ? businessIntelligenceApi.getDashboards()
          : $q.when({})
    }
  })
  .state({
    controller : 'BranchContactsCtrl',
    name       : 'app.branches.contacts',
    templateUrl: BranchContactsHtml,
    url        : '/contacts',
    resolve    : {
      matches: ( BranchContacts : any ) : ng.IPromise<any> => new BranchContacts().getMatches()
    }
  })
  .state({
    controller : 'BranchStockTransferCtrl',
    name       : 'app.branches.stock-transfer',
    templateUrl: BranchStockTransferHtml,
    url        : '/stock-transfer',
    resolve    : {
      companies: ( branchesApi : any ) : ng.IPromise<any> => branchesApi.getFranchiseLinks()
    }
  });
}
